import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FlexGrid } from '@grapecity/wijmo.grid';

import { PlessAlert } from '../../../../shared/pless-alert/pless-alert.component';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

import { KYMW00Model } from '../../../../commons/kymw00/kymw00.model';
import { KYMW1400KomaPageModel } from './kymw1400-koma-page.model';
import { KYMW1400Model } from '../kymw1400.model';
import { CoopCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { PageComboBoxComponent } from '../../../../commons/kymw02/combo-box/page-combo-box/page-combo-box.component';
import { PageComponent } from '../page/page.component';

import { GetPageService } from '../api-services/get-page.service';
import { GetPlanSummaryTableService } from '../api-services/get-plan-summary-table.service';
import { LockKomaEditService } from '../api-services/lock-koma-edit.service';
import { SetOrderNumSeqNoService } from '../api-services/set-order-num-seq-no.service';
import { PageLockService } from '../../../../commons/kymw00/api-services/page-lock.service';
import { EventArgs } from '@grapecity/wijmo';

/**
 * コマ割（共通ページ）を管理するクラス
 *
 * @export KYMW1400KomaPageComponent
 * @class KYMW1400KomaPageComponent
 */
@Component({
  selector: 'app-kymw1400-koma-page',
  templateUrl: 'kymw1400-koma-page.component.html',
  styleUrls: ['kymw1400-koma-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: GetPageService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new GetPageService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
    {
      provide: GetPlanSummaryTableService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new GetPlanSummaryTableService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },

  ]
})
export class KYMW1400KomaPageComponent extends PlessViewHelperSub implements OnInit {
  @Input() leftOrRight: string;
  @ViewChild('hsl_Size', { static: true }) hsl_Size: ElementRef;
  @ViewChild('dgv_PlanSummaryTable', { static: true }) dgv_PlanSummaryTable: FlexGrid;

  @ViewChild('sliderTooltip', { static: true }) tooltip: ElementRef;

  @ViewChild('cmb_Coop', { static: true }) cmb_Coop: CoopCodeComboBoxComponent;
  @ViewChild('cmb_Page', { static: true }) cmb_Page: PageComboBoxComponent;

  @ViewChild('btn_PageLock', { static: true }) btn_PageLock: ElementRef;

  @ViewChild('page', { static: true }) page: PageComponent;

  public leftPage = String('left');
  public rightPage = String('right');

  public kymw1400KomaPageModel: KYMW1400KomaPageModel = new KYMW1400KomaPageModel();

  public readonly BUTTON_STYLE_DEFAULT: string = String('default');
  public readonly BUTTON_STYLE_SELECTED: string = String('selected');
  // ボタンスタイル初期値
  public clsPageLock = this.BUTTON_STYLE_DEFAULT;
  public clsKomaShow = this.BUTTON_STYLE_DEFAULT;

  public styleToolTipLeft = Number(0);

  /**
   *Creates an instance of KYMW1400KomaPageComponent.
   * @param {PlessDialogServiceSub} dialogService
   * @param {LockKomaEditService} lockKomaEditService
   * @param {SetOrderNumSeqNoService} setOrderNumSeqNoService
   * @param {KYMW00Model} kymw00Model
   * @param {KYMW1400Model} kymw1400Model
   * @param {PageLockService} pageLockServiceSub
   * @param {ElementRef} el
   * @param {GetPlanSummaryTableService} getPlanSummaryTableService
   * @param {GetPageService} getPageService
   * @memberof KYMW1400KomaPageComponent
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private lockKomaEditService: LockKomaEditService,
    private setOrderNumSeqNoService: SetOrderNumSeqNoService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public kymw1400Model: KYMW1400Model,
    private pageLockServiceSub: PageLockService,
    public getPlanSummaryTableService: GetPlanSummaryTableService,
    public getPageService: GetPageService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public ngOnInit(): void {
    this.kymw1400KomaPageModel.kymw1400KomaPageComponent = this;
    // PlessViewHelperSubで使用しているサービスを設定
    this.pageLockService = this.pageLockServiceSub;

    // 選択バーカラー指定
    this.kymw1400Model.leftView.kymw1400KomaPageModel.selectedBarStyle = 'selectedBarColor';
    this.kymw1400Model.rightView.kymw1400KomaPageModel.selectedBarStyle = 'noSelectedBarColor';

    // TabIndex設定
    if (this.leftOrRight === this.rightPage) {
      this.popupView = 'KYMW1400KomaPageRight';
    } else {
      this.popupView = 'KYMW1400KomaPageLeft';
    }

    // 計画値集計表取得
    this.kymw1400KomaPageModel.initPlanSummaryTable();

    // グリッド初期処理
    setTimeout(() => {
      this.gridInit();
    });
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW1400KomaPageComponent
   */
  private gridInit(): void {
    this.dgv_PlanSummaryTable.select(-1, -1);
    this.dgv_PlanSummaryTable.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dgv_PlanSummaryTable.select(-1, -1);
    });


  }

  /**
   * 表示中のページデータが更新された時に実行
   *
   * @param {*} pageData
   * @memberof KYMW1400KomaPageComponent
   */
  public bindPage_CHANGEHandler(pageData: any): void {
    if (pageData != null) {
      // データ設定
      this.page.setData(pageData);

      // テンプレート名設定
      this.kymw1400KomaPageModel.templateName = pageData.TemplateName;
      this.kymw1400KomaPageModel.pageLock = this.clsPageLock !== this.BUTTON_STYLE_SELECTED;
      this.page.lock = this.kymw1400KomaPageModel.pageLock ||
        this.kymw1400KomaPageModel.komaType !== this.kymw1400KomaPageModel.KOMATYPE_MOVE;

      // ページはみ出す対応 START
      this.cmb_Page.setPageId(this.page.pageId);
      // ページはみ出す対応 END
    }

    // モードレスでポップアップしている画面を再表示する。
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();
  }

  /**
   * サイズをページに合わせる
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public justScale(): void {
    // canvasの情報取得用
    const canvas: HTMLElement =
      this.elementRef.nativeElement.parentElement.querySelector('#canvas');
    const pageWidth = this.page.width;
    const pageHeight = this.page.height;

    // canvasのheightから、padding分を先に引いて計算
    const rw = Number((canvas.offsetWidth - 25) / pageWidth);
    const rh = Number((canvas.offsetHeight - 25) / pageHeight);

    let ratio: number;
    ratio = Number(Math.min(rw, rh));
    ratio = Number(Math.max(ratio, 0.5));
    ratio = Number(Math.min(ratio, 4.0));

    // サイズ調整バーの値を変更する
    this.kymw1400KomaPageModel.sliderValue = Math.floor(ratio * 10) * 10;
    this.hsl_Size.nativeElement.value = this.kymw1400KomaPageModel.sliderValue;
  }

  /**
   *【拡大バー】の操作をユーザーが行った時に呼ばれるメソッド。
   * 選択された値に合わせて、表示ページの拡大・縮小を行う。
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public bindSize_CHANGEHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.page.pageId)) {
      this.page.reDraw();
    }
  }

  /**
   * 同じページが選択されたのかチェック
   *
   * @private
   * @returns {boolean}
   * @memberof KYMW1400KomaPageComponent
   */
  private isSamePageSelected(): boolean {
    if (this.kymw1400Model.leftView.cmb_Page.selectedPageId ===
      this.kymw1400Model.rightView.cmb_Page.selectedPageId) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 【編集ロックボタン】をユーザーが押した時に呼ばれるメソッド。
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventPageLock_CLICKHandler(): void {
    if (this.clsPageLock === this.BUTTON_STYLE_DEFAULT) {
      this.setLockButtonStyle(true);
      // 進捗状況・工程によるロック判定
      const vo = this.kymw1400Model.getLockKomaEditVO();
      this.lockKomaEditService.execute(this.kymw1400Model, vo);
    } else {
      this.setLockButtonStyle(false);
      this.checkPageLock();
    }
  }

  /**
   * 編集ロック（進捗状況・工程によるロック判定）後処理
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public checkPageLock(): void {
    // ページロックの制御を行う
    if (this.clsPageLock === this.BUTTON_STYLE_SELECTED) {
      this.LockUtilForPage('REGIST'
        , this.kymw1400Model.selectedOrderCode
        , this.kymw1400Model.selectedMediumType
        , Number(this.cmb_Page.selectedPageId)
        , (param) => {
          this.changeLockMode();
        }
        , null
        , (param: any, result: any) => {
          this.setLockButtonStyle(false);		// 失敗時はボタンを元に戻す
          let UserName = '';
          if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
            UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
          } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
            UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
          } else {
            UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
          }
          this.dialogService.openAlertGetMessage('E0141', [UserName]);
        }
        , null
        , false);
    } else {
      this.LockUtilForPage('RELEASE'
        , this.kymw1400Model.selectedOrderCode
        , this.kymw1400Model.selectedMediumType
        , Number(this.cmb_Page.selectedPageId)
        , (param) => {
          this.changeLockMode();
        }
        , null
        , (param) => {
          this.setLockButtonStyle(true); // 失敗時はボタンを元に戻す
        }
        , null
        , false);
    }

    this.btn_PageLock.nativeElement.focus();
  }

  /**
   *  編集ロック処理完了後処理
   *
   * @private
   * @memberof KYMW1400KomaPageComponent
   */
  private changeLockMode(): void {
    this.kymw1400KomaPageModel.pageLock = this.clsPageLock !== this.BUTTON_STYLE_SELECTED;
    this.page.lock = this.kymw1400KomaPageModel.pageLock ||
      this.kymw1400KomaPageModel.komaType !== this.kymw1400KomaPageModel.KOMATYPE_MOVE;

    // 画面メニュー、ボタンの活性化・非活性化制御を行う
    this.kymw1400Model.updateMenuAndButtonEnable();

    // モードレスでポップアップしている画面を再表示する。
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();
  }

  /**
   *【画面に合わせて拡大ボタン】をユーザーが押下した時に呼ばれるメソッド。
   * ページ表示領域内に収まる倍率の中で、最大の倍率でページが表示されるようにする。
   *
   * @returns {void}
   * @memberof KYMW1400KomaPageComponent
   */
  public eventAdjust_CLICKHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.page.pageId)) {
      return;
    }
    this.justScale();
    this.page.reDraw();
  }

  /**
   * フォント変更時
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventFontSize_CHANGEHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.page.pageId)) {
      this.page.reDraw();
    }
  }

  /**
   * ページコンボ変更時
   *
   * @returns {void}
   * @memberof KYMW1400KomaPageComponent
   */
  public eventPage_CHANGEHandler(): void {
    this.changePage(this.cmb_Page.selectedPageId);
  }

  public eventPrev_CHANGEHandler() {
    const currentPageIndex = this.cmb_Page.model.pageList.findIndex(page => page.PageId === this.page.pageId);
    if (currentPageIndex === -1) {
      return;
    }
    const prevPageId = this.cmb_Page.model.pageList[currentPageIndex - 1].PageId;
    this.cmb_Page.setPageId(prevPageId);
    this.changePage(prevPageId);
  }

  public eventNext_CHANGEHandler() {
    const currentPageIndex = this.cmb_Page.model.pageList.findIndex(page => page.PageId === this.page.pageId);
    const nextPageId = this.cmb_Page.model.pageList[currentPageIndex + 1].PageId;
    this.cmb_Page.setPageId(nextPageId);
    this.changePage(nextPageId);
  }

  private changePage(selectedPageId: string) {
    if (!PlessViewUtilsSub.isEmpty(selectedPageId) && this.isSamePageSelected()) {
      this.cmb_Page.setPageId(this.page.pageId);
      this.dialogService.openAlertGetMessage('E0179');
      return;
    }

    // ページはみ出す対応 START
    this.cmb_Page.coopCode = this.cmb_Coop.selectedCoopCode;
    // ページはみ出す対応 END

    // "ページ番号"が選択された場合、左右で同じ「ページ」を選択した場合、以下のメッセージを表示して処理を終了する
    let pageId = Number(-1);
    if (!PlessViewUtilsSub.isEmpty(selectedPageId)) {
      // ページ初期化
      this.page.clear();

      // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
      this.kymw1400Model.kymw1400Component.dispatchGetPageEvent();

      // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
      this.kymw1400Model.kymw1400Component.dispatchGetPlanSummaryTableEvent();
      pageId = -1;
      // 変更前ページのロック情報を解除し、選択されたページを保持する

      if (this.kymw1400Model.leftPageSelected === true) {
        pageId = this.kymw1400Model.leftPageId;
        this.kymw1400Model.leftPageId = Number(selectedPageId);
      } else {
        pageId = this.kymw1400Model.rightPageId;
        this.kymw1400Model.rightPageId = Number(selectedPageId);
      }
      if (pageId !== -1) {
        this.LockUtilForPage('RELEASE'
          , this.kymw1400Model.orderCode
          , this.kymw1400Model.mediumType
          , pageId
          , null
          , null
          , null
          , null
          , false);
      }
      this.kymw1400KomaPageModel.pageLockEnable =
        this.kymw1400Model.funcPermission === this.sharedModel.FUNC_PERMISSION_FULLCONTROL ? true : false;
    } else {
      // 関連画面項目初期化
      // テンプレート名の初期化
      this.kymw1400KomaPageModel.templateName = '';
      this.clsPageLock = this.BUTTON_STYLE_DEFAULT;
      this.clsKomaShow = this.BUTTON_STYLE_DEFAULT;
      this.kymw1400KomaPageModel.initPlanSummaryTable();

      this.page.clear();

      this.cmb_Page.setPageId('');

      // 変更前ページのロック情報を解除し、選択されたページを保持する
      pageId = -1;
      if (this.kymw1400Model.leftPageSelected === true) {
        pageId = this.kymw1400Model.leftPageId;
        this.kymw1400Model.leftPageId = -1;
      } else {
        pageId = this.kymw1400Model.rightPageId;
        this.kymw1400Model.rightPageId = -1;
      }
      if (pageId !== -1) {
        this.LockUtilForPage('RELEASE'
          , this.kymw1400Model.orderCode
          , this.kymw1400Model.mediumType
          , pageId
          , null
          , null
          , null
          , null
          , false);
      }
      this.kymw1400KomaPageModel.pageLockEnable = false;
    }

    // ページロック状態の設定
    this.setLockButtonStyle(false);

    // 画面メニュー、ボタンの活性化・非活性化制御を行う
    this.kymw1400Model.updateMenuAndButtonEnable();
    this.updatePageButtonEnable(selectedPageId);
  }

  /**
   * 会員生協コンボフォーカス時
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventCoop_FOCUSHandler(): void {
    // ヘッダの選択色変更
    if (this.leftOrRight === this.leftPage) {
      this.kymw1400Model.kymw1400Component.pv_PageViewLeft.eventWindow_MOUSE_DOWNHandler();
    } else {
      this.kymw1400Model.kymw1400Component.pv_PageViewRight.eventWindow_MOUSE_DOWNHandler();
    }
  }

  private updatePageButtonEnable(selectedPageId: string) {
    const currentPageIndex = this.cmb_Page.model.pageList.findIndex(page => page.PageId === selectedPageId);
    // blankの選択肢が選択されている場合
    if (currentPageIndex === 0) {
      this.kymw1400KomaPageModel.prevEnable = false;
      this.kymw1400KomaPageModel.nextEnable = false;
      return;
    }
    if (currentPageIndex === 1) {
      this.kymw1400KomaPageModel.prevEnable = false;
      this.kymw1400KomaPageModel.nextEnable = true;
      return;
    }

    const isLastPage = currentPageIndex === this.cmb_Page.model.pageList.length - 1;
    if (isLastPage) {
      this.kymw1400KomaPageModel.prevEnable = true;
      this.kymw1400KomaPageModel.nextEnable = false;
      return;
    }

    this.kymw1400KomaPageModel.prevEnable = true;
    this.kymw1400KomaPageModel.nextEnable = true;
  }

  /**
   * 会員生協コンボ変更時
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventCoop_CHANGEHandler(): void {
    // 変更前のページ番号を保持
    this.cmb_Page.setPageNum(this.cmb_Page.selectedPageNum);
    // ページ再表示用インターフェースに自身を設定
    this.cmb_Page.setIPageView(this);
    if (!PlessViewUtilsSub.isEmpty(this.cmb_Coop.selectedCoopCode)) {
      this.clear(false);
    } else {
      this.cmb_Coop.setCoopCode('');
      this.clear(false);
    }

    // モードレスでポップアップしている画面を再表示する。
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();
  }

  /**
   * 選択済みのページ情報を更新する
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public updatePageInfo(): void {
    this.eventPage_CHANGEHandler();
  }

  /**
   * ページ情報の再表示を行う
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public reloadPageInfo(): void {
    // 再表示ボタン押下イベント
    this.eventReload_CHANGEHandler();
  }

  /**
   *【拡大バー】の操作をユーザーが行った時に呼ばれるメソッド。
   * 選択された値に合わせて、表示ページの拡大・縮小を行う。
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventSize_CHANGEHandler(): void {
    // 画面スライダー値変更
    this.kymw1400KomaPageModel.sliderValue = Number(this.hsl_Size.nativeElement.value);

    if (!PlessViewUtilsSub.isEmpty(this.page.pageId)) {
      this.page.reDraw();
    }
  }

  /**
   * コマ表示ボタン押下時
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventKomaShow_CHANGEHandler(): void {
    this.kymw1400KomaPageModel.allKomaVisible = !this.kymw1400KomaPageModel.allKomaVisible;
    if (this.kymw1400KomaPageModel.allKomaVisible) {
      this.clsKomaShow = this.BUTTON_STYLE_DEFAULT;
      this.kymw1400KomaPageModel.srcKomaVisible = './assets/icons/KYMW14/komavisible.png';
    } else {
      this.clsKomaShow = this.BUTTON_STYLE_SELECTED;
      this.kymw1400KomaPageModel.srcKomaVisible = './assets/icons/KYMW14/komainvisible.png';
    }
    this.page.komaShow();
  }

  /**
   * 再表示ボタン押下時
   *
   * @param e:イベント
   */
  public eventReload_CHANGEHandler(): void {
    // ページ初期化
    this.page.clear();

    // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
    this.kymw1400Model.kymw1400Component.dispatchGetPageEvent();

    // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
    this.kymw1400Model.kymw1400Component.dispatchGetPlanSummaryTableEvent();

    // モードレスでポップアップしている画面を再表示する。（企画商品のロックはそのまま）
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog(true, true, true, true, true, true, false);
  }

  /**
   * Seq.No一括セットボタン押下時
   *
   * @param e:イベント
   */
  public eventSeqNoSet_CLICKHandler(): void {
    // 変更確認のメッセージを表示する。「NO」が選択された場合は処理を終了する。
    this.dialogService.openAlertGetMessage('Q0121',
      null,
      (closeDetail) => {
        this.eventSeqNoSet_CLICKHandlerYesNo(closeDetail);
      });
  }

  /**
   * Seq.No一括セットボタン押下時アラート選択
   *
   * @param e:イベント
   */
  private eventSeqNoSet_CLICKHandlerYesNo(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 注文コードSEQ№一括設定要求(/KYMW14/setOrderNumSeqNo.xml)をサーバに送信する。
      const vo = this.kymw1400Model.getPageIDVO();
      this.setOrderNumSeqNoService.execute(vo, () => {
        this.eventSeqNoSet_CLICKHandlerYesNoSuccess();
      });
    }
  }

  /**
   * Seq.No一括セットボタン押下時アラート選択Yes成功時
   *
   * @param e:イベント
   */
  private eventSeqNoSet_CLICKHandlerYesNoSuccess(): void {
    // ページ初期化
    this.page.clear();

    // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
    this.kymw1400Model.kymw1400Component.dispatchGetPageEvent();

    // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
    this.kymw1400Model.kymw1400Component.dispatchGetPlanSummaryTableEvent();
  }

  /**
   * 選択ページレイアウトの初期化処理を行う
   *
   * @param clearFlg:True全部クリア、false：ページ情報のみクリア
   */
  public clear(clearFlg = true): void {
    this.kymw1400KomaPageModel.clear();
    if (clearFlg) {
      this.cmb_Coop.setCoopCode('');
      this.kymw1400KomaPageModel.sliderValue = 160;
      this.kymw1400KomaPageModel.fontSize = 10;
    }
    this.cmb_Page.setPageId('');
    this.kymw1400KomaPageModel.pageLockEnable = false;
    this.setLockButtonStyle(false);
    this.clsKomaShow = this.BUTTON_STYLE_DEFAULT;
    this.kymw1400KomaPageModel.reloadEnable = false;
    // テンプレート名の初期化
    this.kymw1400KomaPageModel.templateName = '';
    this.page.clear();

    // コマ非表示の場合、表示させる
    if (!this.kymw1400KomaPageModel.allKomaVisible) {
      this.eventKomaShow_CHANGEHandler();
    }

    // ロック情報の解除処理を行う
    let pageId = Number(-1);
    if (this.kymw1400Model.leftPageSelected === true) {
      pageId = this.kymw1400Model.leftPageId;
      this.kymw1400Model.leftPageId = -1;
    } else {
      pageId = this.kymw1400Model.rightPageId;
      this.kymw1400Model.rightPageId = -1;
    }
    if (pageId !== -1) {
      this.LockUtilForPage('RELEASE'
        , this.kymw1400Model.orderCode
        , this.kymw1400Model.mediumType
        , pageId
        , () => {
          this.clearPlanGoodsLock();
        }
        , null
        , null
        , null
        , false);
    }
  }

  /**
   * 選択ページ内の企画商品ロック情報を解除する
   *
   * @param leftPageFlg:True左ページ、false：右ページ
   */
  public clearPlanGoodsLock(): void {
    this.kymw1400Model.kymw1400Component.releaseAllPlanGoodsLock();
  }

  /**
   * ロックボタンスタイル制御
   *
   * @param {boolean} selected
   * @memberof KYMW1400KomaPageComponent
   */
  public setLockButtonStyle(selected: boolean) {
    if (selected) {
      this.clsPageLock = this.BUTTON_STYLE_SELECTED;
      this.kymw1400KomaPageModel.srcLock = './assets/icons/KYMW14/unlock.png';
    } else {
      this.clsPageLock = this.BUTTON_STYLE_DEFAULT;
      if (this.kymw1400KomaPageModel.pageLockEnable) {
        this.kymw1400KomaPageModel.srcLock = './assets/icons/KYMW14/lock.png';
      } else {
        this.kymw1400KomaPageModel.srcLock = './assets/icons/KYMW14/disabledlock.png';
      }
    }
  }

  /**
   * 倍率スライダーのツールチップの描画設定を行う
   *
   * @memberof KYMW1400KomaPageComponent
   */
  viewSliderTooltip(): void {
    let left = this.hsl_Size.nativeElement.value - 100;
    if (left < 0) {
      // 100%未満は1.5px
      left = left * 0.15;
    } else {
      // 100%以上は2px
      left = left * 0.2;
    }

    // 計算値をツールチップのleftへ設定
    this.tooltip.nativeElement.style.left = (-3 + left) + 'px';
    // スライダーの現在値をツールチップのテキストへ設定
    this.tooltip.nativeElement.textContent = Number(this.hsl_Size.nativeElement.value).toFixed(2);
  }

  /**
   * キャンセルボタン押下時イベント
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventCancel_CLICKHandler(): void {
    this.resetKomaTypeAction();
  }

  /**
   * コマタイプ変更時イベント
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public eventKomaType_CHANGEHandler(): void {
    // 左右どちらかで選択したコマタイプを左右両方のコマタイプに反映する
    const komaType = this.kymw1400KomaPageModel.komaType;
    this.kymw1400Model.leftView.kymw1400KomaPageModel.komaType = komaType;
    this.kymw1400Model.rightView.kymw1400KomaPageModel.komaType = komaType;

    this.resetKomaTypeAction();

    this.kymw1400Model.leftView.changeLockMode();
    this.kymw1400Model.rightView.changeLockMode();
  }

  /**
   * コマタイプ変更時のリセット処理
   *
   * @memberof KYMW1400KomaPageComponent
   */
  public resetKomaTypeAction() {
    // ロック全解除
    this.kymw1400Model.kymw1400Component.releaseAllPlanGoodsLock();

    // すべてのコマを未選択色に設定
    this.kymw1400Model.leftView.page.setAllKomaColor(true);
    this.kymw1400Model.rightView.page.setAllKomaColor(true);

    // コマ選択情報の削除
    this.kymw1400Model.leftView.page.setSelectedKoma('');
    this.kymw1400Model.leftView.page.clarSelectedKoma();
    this.kymw1400Model.rightView.page.setSelectedKoma('');
    this.kymw1400Model.rightView.page.clarSelectedKoma();

    // 初期化
    this.kymw1400Model.pcodeList = [];

    // モードレスでポップアップしている画面を再表示する。
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();

  }
}
